import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import AiToolTemplateV2 from '../../AiToolTemplate/AiToolTemplateV2';
import { createComponentConfig, createComponentItem, COMPONENT_TYPES, PROMPT_STRATEGIES, TOOL_IDS } from '../../AiToolTemplate/config/componentConfig';

const GroupPhoto = () => {
  const { t } = useI18n();

  const config = createComponentConfig({
    toolName: t('aiWorkbench.tools.groupPhoto.title') || '合照',
    toolIcon: '👥',
    toolDescription: t('aiWorkbench.tools.groupPhoto.description') || t('aiWorkbench.tools.groupPhoto.ui.promptDescription'),
    gradientColors: ['#4facfe', '#00f2fe'],
    apiEndpoint: '/generate-image/edit',
    apiParams: {},
    components: [
      createComponentItem({
        id: 'photos',
        type: COMPONENT_TYPES.IMAGE_UPLOAD,
        title: t('aiWorkbench.tools.groupPhoto.ui.uploadTitle'),
        description: t('aiWorkbench.tools.groupPhoto.ui.uploadDescription', { max: 14 }),
        required: true,
        props: { multiple: true, preview: true, gridItemHeight: 100, maxFiles: 14, uploadAreaHeight: 120 },
        promptKey: 'images',
        order: 1
      }),
      createComponentItem({
        id: 'size',
        type: COMPONENT_TYPES.SIZE_SELECTOR,
        title: t('aiWorkbench.aspectRatio'),
        required: true,
        defaultValue: 'Auto',
        order: 2
      }),
      createComponentItem({
        id: 'groupMainCategory',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'groupMainCategory',
          allowMultiple: false
        },
        order: 3
      }),
      createComponentItem({
        id: 'groupSubScene',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'groupSubScene',
          allowMultiple: false
        },
        order: 4
      }),
      createComponentItem({
        id: 'groupLayout',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'groupLayout',
          allowMultiple: false
        },
        order: 5
      }),
      createComponentItem({
        id: 'groupTechnical',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'groupTechnical',
          allowMultiple: false
        },
        order: 6
      }),
      createComponentItem({
        id: 'extraPrompt',
        type: COMPONENT_TYPES.PROMPT_INPUT,
        title: t('aiWorkbench.tools.groupPhoto.ui.promptTitle'),
        description: t('aiWorkbench.tools.groupPhoto.ui.promptDescription'),
        required: false,
        props: { placeholder: t('aiWorkbench.tools.groupPhoto.ui.promptPlaceholder') },
        promptKey: 'prompt',
        order: 7
      })
    ],
    promptConfig: {
      strategy: PROMPT_STRATEGIES.CUSTOM,
      customHandler: (values) => {
        return values.extraPrompt;
      }
    },
    additionalParams: {
      width: 1024,
      height: 1024,
      model: 'nano'
    },
    layout: 'default'
  });

  return (
    <AiToolTemplateV2
      toolName={config.toolName}
      toolIcon={config.toolIcon}
      toolDescription={config.toolDescription}
      config={config}
      gradientColors={config.gradientColors}
      toolId={TOOL_IDS.GROUP_PHOTO}
    />
  );
};

export default GroupPhoto;
